export default () => ({
	blog_handle: '',
	articles: [],
	current_tag: '',
	current_tag_handle: '',
	tagged_articles: [],
	start_pagination: 6,
	pagination: 0,
	url: window.location.pathname,
	show_all: true,
	animation: true,

	async getArticlesData() {
		const url = `${window.Shopify.routes.root}blogs/${this.blog_handle}?view=data`;
		const responce = await fetch(url);
		const result = await responce.json();
		this.articles = result;
		this.animation = false;
	},

	filterBlog(handle, tag) {
		this.animation = true;
		if (tag === 'all') {
			if (this.$refs.blog.dataset.tags !== '') {
				const url = `${window.Shopify.routes.root}blogs/${this.blog_handle}`;

				fetch(url)
					.then((res) => res.text())
					.then((data) => {
						const parser = new DOMParser().parseFromString(data, 'text/html');
						const blog = parser.querySelector('.blog__container');
						this.$refs.blog.querySelector('.blog__container').innerHTML = blog.innerHTML;
					});
			}
			this.show_all = true;
			this.current_tag = this.$refs.blog.dataset.all;
			this.current_tag_handle = '';
		} else {
			this.show_all = false;
			this.current_tag = tag;
			this.current_tag_handle = handle;
			this.tagged_articles = this.articles.filter((article) => article.tag_handle === handle);
		}
		this.pagination = this.start_pagination;
		this.setUrl();
		const sorting = document.getElementById('blog-sorting');
		sorting.value = 'date';
		setTimeout(() => {
			this.animation = false;
		}, 300);
	},

	sortArticles(event) {
		const sorting_option = event.target.value;
		if (sorting_option === 'date') {
			this.tagged_articles = this.tagged_articles.sort(
				(a, b) => new Date(b.published_at) - new Date(a.published_at),
			);
		} else {
			this.tagged_articles = this.tagged_articles.sort(
				(a, b) => new Date(a.published_at) - new Date(b.published_at),
			);
		}
	},

	setUrl() {
		let new_url = '';
		if (this.current_tag_handle === '') {
			new_url = `${window.Shopify.routes.root}blogs/${this.blog_handle}`;

			window.history.pushState({}, '', new_url);
		} else {
			new_url = `${window.Shopify.routes.root}blogs/${this.blog_handle}/tagged/${this.current_tag_handle}`;
			window.history.pushState({}, '', new_url);
		}
	},

	setDataFromUrl(url) {
		this.animation = true;
		if (url.includes('tagged')) {
			const tag = url.split('tagged/')[1];
			this.show_all = false;
			this.tagged_articles = this.articles.filter((article) => article.tag_handle === tag);
			this.current_tag_handle = tag;

			this.current_tag = this.tagged_articles[0].tag;
		} else {
			if (this.$refs.blog.dataset.tags !== '') {
				const url = `${window.Shopify.routes.root}blogs/${this.blog_handle}`;

				fetch(url)
					.then((res) => res.text())
					.then((data) => {
						const parser = new DOMParser().parseFromString(data, 'text/html');
						const blog = parser.querySelector('.blog__container');
						this.$refs.blog.querySelector('.blog__container').innerHTML = blog.innerHTML;
					});
			}
			this.show_all = true;
			this.current_tag = this.$refs.blog.dataset.all;
			this.current_tag_handle = '';
		}
		setTimeout(() => {
			this.animation = false;
		}, 300);
	},

	loadMore() {
		this.pagination += this.start_pagination;
	},

	init() {
		this.$watch('blog_handle', () => {
			this.getArticlesData();
		});

		this.$watch('articles', () => {
			this.tagged_articles = this.articles.filter(
				(article) => article.tag_handle === this.articles[0].tag_handle,
			);
			this.current_tag = this.$refs.blog.dataset.all;
			this.pagination = this.start_pagination;

			this.setDataFromUrl(this.url);
		});

		window.addEventListener('popstate', () => {
			const url = window.location.pathname;
			this.setDataFromUrl(url);
		});
	},
});
